import { useEffect } from 'react';
import * as gtag from '@/common/utils/gtags.client';
import { Location } from 'react-router';

export function useGTMPageView(location: Location): void {
  useEffect(() => {
    gtag.pushData({ path: location.pathname });
    gtag.event('pageView');
  }, [location]);
}
